import { Carousel } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AOS from "aos";
import "aos/dist/aos.css";

export const ImageGallerySlider = () => {
  const [Imgindex, setImgIndex] = useState(0);

  const gallery = useSelector(
    (state) => state.gallery.image.gallery.galleryImages
  );

  const imageArray = Object.values(gallery);

  const groupedImages = [];
  for (let i = 0; i < imageArray.length; i += 2) {
    groupedImages.push([imageArray[i], imageArray[i + 1]]);
  }

  const handleSelectImg = (selectedIndex) => {
    setImgIndex(selectedIndex);
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="gallery-section" data-aos="fade-up">
      <h1 data-aos="zoom-in">
        <span>Gallery</span> in Adhie Annan Temple
      </h1>

      <div className="gallery-flex">
        <div className="gallery-carousel" data-aos="fade-right">
          <Carousel
            slide
            controls={true}
            indicators={false}
            interval={3000}
            activeIndex={Imgindex}
            onSelect={handleSelectImg}
            className="custom-carousel"
          >
            {groupedImages.map((pair, index) => (
              <Carousel.Item key={index}>
                <div className="dual-image-slide">
                  {pair.map((imgSrc, i) => (
                    <img
                      key={i}
                      className="carousel-image"
                      src={imgSrc}
                      alt={`Gallery Slide ${index}-${i}`}
                    />
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>

          <div className="custom-indicators">
            {groupedImages.map((_, i) => (
              <span
                key={i}
                className={`dot ${Imgindex === i ? "active" : ""}`}
                onClick={() => setImgIndex(i)}
              ></span>
            ))}
          </div>
        </div>

        <div className="gallery-text" data-aos="fade-left">
          <p style={{ color: "#333" }}>
            Explore our photo gallery to see the peaceful and beautiful moments
            at Adhie Annan Temple. From the colorful tower to the calm
            surroundings, each photo shows the temple’s spiritual and cultural
            charm.
            <br />
            அதி அன்னான் கோயிலின் அமைதியான மற்றும் அழகான தருணங்களைக் காண எங்கள்
            புகைப்படத் தொகுப்பை ஆராயுங்கள். வண்ணமயமான கோபுரத்திலிருந்து அமைதியான
            சூழல் வரை, ஒவ்வொரு புகைப்படமும் கோயிலின் ஆன்மீக மற்றும் கலாச்சார
            அழகைக் காட்டுகிறது.
          </p>
        </div>
      </div>
    </div>
  );
};
